export enum StageState {
  Planned = 'Prévue',
  InProgress = 'En cours',
  Conducted = 'Réalisée',
  Interrupted = 'Interrompue',
  Refused = 'Refusée par le bénéficiaire',
  RefusedOrganization = 'Refusée par l’organisme',
  Canceled = 'Annulée',
  AbsenceJustified = 'Absence justifiée',
  AbsenceNotJustified = 'Absence non justifiée',
}

export const labelsByStageState: Map<StageState, string> = new Map<StageState, string>(
  Object.keys(StageState).map((x: string) => [x, StageState[x]] as [StageState, string]),
);
